import React from 'react';
import {LoaderMUI} from '../../../shared';
import './LoadPanel.scss';
const LoadPanel = ({staticPos = false, noBg = false, circleSize = 120}) => {
  return (
    <div className={'loadPanel'}>
      <LoaderMUI staticPos={staticPos} noBg={noBg} circleSize={circleSize} />
    </div>
  );
};

export default LoadPanel;
